type PageMeta = {
  description: string;
  image?: string;
  title: string;
  url?: string;
};

const managedProperties = ["og:type", "og:title", "og:description", "og:image", "og:url"];
const managedNames = ["description", "twitter:card", "twitter:title", "twitter:description", "twitter:image"];

function ensureMeta(attribute: "name" | "property", key: string) {
  const selector = `meta[${attribute}="${key}"]`;
  const existingMeta = document.head.querySelector<HTMLMetaElement>(selector);

  if (existingMeta) {
    return existingMeta;
  }

  const meta = document.createElement("meta");
  meta.setAttribute(attribute, key);
  document.head.appendChild(meta);
  return meta;
}

function setMeta(attribute: "name" | "property", key: string, content: string) {
  ensureMeta(attribute, key).setAttribute("content", content);
}

export function updatePageMeta({ description, image, title, url }: PageMeta) {
  document.title = title;

  // SPA 내부 이동 후에도 공유/복사 시 현재 화면의 메타 정보가 유지되도록 head를 갱신한다.
  setMeta("name", "description", description);
  setMeta("property", "og:type", "profile");
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url || window.location.href);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);

  if (image) {
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:image", image);
  }
}

export function resetManagedPageMeta() {
  managedProperties.forEach((property) => {
    document.head.querySelector(`meta[property="${property}"]`)?.remove();
  });
  managedNames.forEach((name) => {
    document.head.querySelector(`meta[name="${name}"]`)?.remove();
  });
}
